import type { DefaultTheme } from 'styled-components';
import { css } from 'styled-components';

import { hex2rgba } from '../../../theme/interpolateColors.ts';
import { legacyShadows } from '../../../theme/shadows.ts';
import typography from '../../../theme/typography.ts';

export const PrimaryDark: DefaultTheme = {
  colors: {
    main: '#00B2E3',
    mainDark: '#0087C1',
    mainLight: '#7EE3FF',
    positive120: '#14B877',
    positive100: '#057E4D',
    positive70: '#10593D',
    positive30: '#184C3A',
    positive10: '#223D35',
    critical120: '#FF3345',
    critical100: '#CA2A38',
    critical70: '#822832',
    critical30: '#502B31',
    critical10: '#412C31',
    warning120: '#E8A316',
    warning100: '#B68219',
    warning70: '#815F1C',
    warning30: '#695122',
    warning10: '#3E372D',
    link120: '#4193FF',
    link100: '#2F82FF',
    link70: '#2562C0',
    link30: '#21457C',
    link10: '#273240',
    //
    black_1: '#D3DFEB',
    black_2: '#2E2F33',
    black_3: '#131E29',
    //
    blackDark_1: '#ADB9C4',
    //
    grey00_1: '#2C2D31',
    grey00_2: '#FFFFFF',
    grey00_5: '#ADB9C4',
    grey00_6: '#27282C',
    grey00_7: '#232325',
    //
    grey01_1: '#282A2D',
    grey01_2: '#4B4C55',
    grey01_3: '#37383D',
    //
    grey05_1: '#232325',
    grey05_2: '#45495D',
    grey05_3: '#37383D',
    grey05_4: '#37383D',
    //
    grey10_1: '#32343E',
    grey10_2: '#37383D',
    grey10_5: '#45495E',
    //
    grey30_1: '#3F4455',
    grey30_2: '#37383D',
    //
    grey70_1: '#88939F',
    grey70_3: '#6D7E89',
    //
    grey100_1: '#9EA8B2',
    grey100_2: '#6D7E89',
    //
    purple120: '#7A05B1',
    purple100: '#5E1383',
    purple70: '#442157',
    purple30: '#372745',
    purple10: '#3A2A4A',
    //
    purpleBlue120: '#4E2AD9',
    purpleBlue100: '#432BA3',
    purpleBlue70: '#382C6C',
    purpleBlue30: '#342C5B',
    purpleBlue10: '#312C4A',
    //
    teal120: '#007474',
    teal100: '#0B6364',
    teal70: '#165153',
    teal30: '#213F42',
    teal10: '#25373B',
    //
    pink120: '#CC3683',
    pink100: '#9A3369',
    pink70: '#67304F',
    pink30: '#542F46',
    pink10: '#442E3E',
    //
    lightBlue120: '#0282CA',
    lightBlue100: '#0E699D',
    lightBlue70: '#1B4F6E',
    lightBlue30: '#214358',
    lightBlue10: '#253A48',
    //
    coral120: '#E24639',
    coral100: '#AB3E36',
    coral70: '#6C3534',
    coral30: '#593333',
    coral10: '#473033',
    //
    green120: '#36AC4A',
    green100: '#338342',
    green70: '#30593A',
    green30: '#2E4D37',
    green10: '#2D4035',
    //
    yellow120: '#DAA71A',
    yellow100: '#A17F21',
    yellow70: '#695729',
    yellow30: '#574C2B',
    yellow10: '#463F2E',
  },
  shadows: {
    ...legacyShadows,
    focus: css`
      box-shadow: 0 0 0 3px ${({ theme }) => hex2rgba(theme.colors.main, 0.35)};
    `,
    error: css`
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.critical10};
    `,
    warning: css`
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.warning10};
    `,
    success: css`
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.positive10};
    `,
    large: css`
      box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.grey10_1};
    `,
    medium: css`
      box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.grey10_1};
    `,
    small: css`
      box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.grey10_1};
    `,
  },
  typography,
  borders: {
    radiusMedium: 8,
  },
  themeId: 'primaryDark',
};
